import { getDeliveryApiBase } from "./deliveryApi";

const TOKEN_KEY = "hei_admin_token";

export function getAdminToken() {
    try {
        return localStorage.getItem(TOKEN_KEY) || "";
    } catch {
        return "";
    }
}

export function setAdminToken(token) {
    try {
        localStorage.setItem(TOKEN_KEY, token);
    } catch {
        /* ignore */
    }
}

export function clearAdminToken() {
    try {
        localStorage.removeItem(TOKEN_KEY);
    } catch {
        /* ignore */
    }
}

/**
 * 调用 Worker 校验 JWT 是否有效（未篡改且未过期）。
 */
export async function verifyAdminToken(token) {
    const base = getDeliveryApiBase();
    if (!base || !token) {
        return false;
    }
    try {
        const response = await fetch(`${base}/auth/verify`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) {
            return false;
        }
        const body = await response.json().catch(() => ({}));
        return Boolean(body.ok);
    } catch {
        return false;
    }
}
